/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ pct: NonNullable<unknown> }} Workout_Readiness_Poor_SleepInputs */

const en_us2_workout_readiness_poor_sleep = /** @type {(inputs: Workout_Readiness_Poor_SleepInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Short night: ${i?.pct}% fewer sets today`)
};

const pt_br2_workout_readiness_poor_sleep = /** @type {(inputs: Workout_Readiness_Poor_SleepInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Noite curta: ${i?.pct}% menos séries hoje`)
};

const es_419_workout_readiness_poor_sleep = /** @type {(inputs: Workout_Readiness_Poor_SleepInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Noche corta: ${i?.pct}% menos series hoy`)
};

const pt_pt2_workout_readiness_poor_sleep = /** @type {(inputs: Workout_Readiness_Poor_SleepInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Noite curta: menos ${i?.pct}% de séries hoje`)
};

const fr_fr2_workout_readiness_poor_sleep = /** @type {(inputs: Workout_Readiness_Poor_SleepInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nuit courte : ${i?.pct} % de séries en moins aujourd'hui`)
};

const de_de2_workout_readiness_poor_sleep = /** @type {(inputs: Workout_Readiness_Poor_SleepInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kurze Nacht: heute ${i?.pct}% weniger Sätze`)
};

const it_it2_workout_readiness_poor_sleep = /** @type {(inputs: Workout_Readiness_Poor_SleepInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Notte corta: ${i?.pct}% di serie in meno oggi`)
};

/**
* | output |
* | --- |
* | "Short night: {pct}% fewer sets today" |
*
* @param {Workout_Readiness_Poor_SleepInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_readiness_poor_sleep = /** @type {((inputs: Workout_Readiness_Poor_SleepInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Readiness_Poor_SleepInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_readiness_poor_sleep(inputs)
	if (locale === "es-419") return es_419_workout_readiness_poor_sleep(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_readiness_poor_sleep(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_readiness_poor_sleep(inputs)
	if (locale === "de-DE") return de_de2_workout_readiness_poor_sleep(inputs)
	if (locale === "it-IT") return it_it2_workout_readiness_poor_sleep(inputs)
	return en_us2_workout_readiness_poor_sleep(inputs)
});
export { workout_readiness_poor_sleep as "workout.readiness_poor_sleep" }